import { useState, useEffect } from 'react'
import { supabase } from '../config/supabase'

const Announcement = () => {
  const [announcement, setAnnouncement] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetchAnnouncement()
  }, [])

  const fetchAnnouncement = async () => {
    try {
      setIsLoading(true)
      // ไม่ใช้ single() แต่ใช้ limit(1) แทน
      const { data, error } = await supabase
        .from('announcements')
        .select('*')
        .eq('is_active', true)
        .order('created_at', { ascending: false })
        .limit(1)

      if (error) {
        throw error
      }

      // เช็คว่ามีข้อมูลหรือไม่
      if (data && data.length > 0) {
        setAnnouncement(data[0])
      }
    } catch (error) {
      console.error('Error fetching announcement:', error.message)
    } finally {
      setIsLoading(false)
    }
  }

  // ถ้ากำลังโหลดหรือไม่มีประกาศ ไม่ต้องแสดงอะไร
  if (isLoading || !announcement) return null

  return (
    <div className="bg-gradient-to-r from-red-600 to-rose-500 text-white">
      <div className="max-w-6xl mx-auto px-4 py-2">
        <div className="flex items-center justify-center gap-2 text-sm">
          <span className="animate-pulse">🔔</span>
          <p>{announcement.message}</p>
        </div>
      </div>
    </div>
  )
}

export default Announcement 